<router-outlet></router-outlet>
<div class="latest-lotteries-results container">
  <div class="bs-row w-100 w-sm-auto">
    <div class="xl-12 md-12 sm-12 xs-12 d-flex flex-column align-items-center">
      <div class="d-flex flex-row justify-content-between mb-4 w-100">
        <h1 class="color-prussian-blue px-3">{{ 'lotteryResult.latestLotteriesResults' | translate }}</h1>
        <span>
          <a [routerLink]="['/' + showLang, 'lotteries-results']" class="tt-capitalize font-proximanova color-cornflower-blue fz-14px me-3">{{ 'lotteryResult.seeAllResults' | translate }}</a>
          <img class="me-3 position-relative t2px h11px" src="../../assets/icons/double_arrow.png" alt="">
        </span>
      </div>
      <div class="flex-container results-list row bs-row bgc-none">
        <div class="results-item col-md-6 my-3 px-4 bd-none" *ngFor="let lottery of lotteries">
          <div [routerLink]="[showLang, 'lotteries-results', lottery.urlLotteryName]" class="align-items-center bgc-link-water bs-row cursor-pointer d-flex flex-column flex-sm-row p-3 px-4 w-sm-100">
            <div class="align-items-center col-12 col-sm-5 container d-flex justify-content-center mt-2 mt-sm-0 name ps-0">
              <div class="bs-row">
                <div class="align-items-center col-5 d-flex">
                  <img class="lottery-logo square-80px" *ngIf="lottery.urlLotteryName" src="../../assets/images/lotteries/{{ lottery.urlLotteryName | lowercase}}/icons/{{ lottery.urlLotteryName | lowercase}}_100x100.png" alt="{{lottery.LotteryName}} Logo">
                </div>
                <div class="col-7 d-flex flex-column justify-content-center">
                <span class="results-item-title">
                  <span class="color-sapphire font-proximanova fw-700 fz-18px title-{{lottery.urlLotteryName}}" *ngIf="lottery.LotteryName === '6aus49'">6 aus 49</span>
                  <span class="color-sapphire font-proximanova fw-700 fz-18px title-{{lottery.urlLotteryName}}" *ngIf="!(lottery.LotteryName === '6aus49')">{{lottery.LotteryName}}</span>
                </span>
                  <div class="fz-15px results-item-data">
                    {{formatDate(lottery.DrawDate)}}
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix col-12 col-sm-7 d-flex justify-content-evenly number-list pe-0">
              <span class="align-items-center blue d-flex justify-content-center num position-relative square-40px mx-0" *ngFor="let winning of lottery.winningNumbers">
                <span class="position-absolute t9px">{{winning}}</span>
              </span>
              <span class="align-items-center d-flex justify-content-center mx-0 num position-relative square-40px yellow" *ngFor="let addWinning of lottery.extraNumbers">
                <span class="position-absolute t9px">{{addWinning}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
